import useSWR from 'swr';

import { fetchData } from '@/helpers/swr';
import { useListEntryCompare } from '@/helpers/_hooks';

// The recently-accessed carousel shows at most the ten most-recent comparisons.
const RECENT_COMPARISON_LIMIT = 10;

const recentComparisonsKey = (limit = RECENT_COMPARISON_LIMIT) => `/recent-comparison?limit=${limit}`;

const useRecentComparisons = (limit = RECENT_COMPARISON_LIMIT) => {
  const swr = useSWR(recentComparisonsKey(limit), fetchData);
  return swr;
};

const useRecentComparisonObject = (uid, limit = RECENT_COMPARISON_LIMIT) => {
  const recentComparisons = useSWR(recentComparisonsKey(limit), fetchData, { compare: useListEntryCompare(uid) });
  return recentComparisons.data.content[uid];
};

export { useRecentComparisons, useRecentComparisonObject };
